import React, { useState } from "react";

import "./stylesPlayersLineChart.css";
import { formatNumber } from "chart.js/helpers";

import CashIcon from "../../../assets/icons/ic_cash.svg";

import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";

function PlayersLineChart({ headers, title, data }) {
  const [activeIndex, setActiveIndex] = useState(0);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${context.dataset.label}: ${formatNumber(
              value,
              "en-US",
              "decimal",
              2
            )}\n`;
          },
        },
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 20,
        displayColors: true,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value / 1000 + "k";
          },
        },
      },
    },
    interaction: {
      mode: "index", // Show tooltip for all datasets at hovered index
      intersect: false,
      axis: "x", // Ensure crosshair lines show on the x-axis
    },
  };
  return (
    <div id="players-line-chart">
      <div className="players-line-chart-header">
        {headers &&
          headers.map((kpi, index) => (
            <div
              key={index}
              className={`players-line-chart-kpi ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="players-line-chart-kpi-title">{kpi.title}</div>
              <div className="players-line-chart-kpi-value">
                <img src={CashIcon} alt="" />
                {formatNumber(kpi.amount, "en-US", {
                  style: "decimal",
                  maximumFractionDigits: 2,
                })}
                <div
                  className={`players-line-chart-kpi-percentage ${
                    kpi.percentage >= 0 ? "up" : "down"
                  }`}
                >
                  {kpi.percentage > 0
                    ? `▲${kpi.percentage}%`
                    : `▼${kpi.percentage}%`}
                </div>
              </div>
            </div>
          ))}
        {title && <h3>{title}</h3>}
      </div>
      <div className="players-line-chart-body">
        <div className="left-content">
          <Line data={data} options={options} />
        </div>
      </div>
    </div>
  );
}

export default PlayersLineChart;
